module.exports = __webpack_public_path__ + "img/9791188547135.71f1efd5.jpg";